// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  jsonHeader,
  postMethod,
  multipartJsonHeader,
}                     from '../fetchTools';

var options = {...defaultOptions, ...jsonHeader};
export const getQualitativeMetricData = (name, params) => {
    console.log("sh get API ")
    console.log(name)
    if (params == null){
        params="";
    }
    const url = `${getLocationOrigin(2)}/${appConfig.qme.data.API}${appConfig.qme.data[name].path}/${params}`
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const postQualitativeMetricData = (name, payload) => {
    console.log("sh post API ")
    console.log(name)
    console.log(payload)
    const url = `${getLocationOrigin(2)}/${appConfig.qme.data.API}${appConfig.qme.data[name].path}/`
    var options = {...defaultOptions, ...postMethod, ...jsonHeader};
    options.method = 'post';
    options.body = JSON.stringify(payload);
    console.log(options)
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => data)
        .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/qualitativeMetric.js